module.exports = __webpack_public_path__ + "static/car-pc/img/right-arrow-2.c99dcce5.svg";